import { render, staticRenderFns } from "./display-contact-link.vue?vue&type=template&id=9161a68a&scoped=true&"
import script from "./display-contact-link.ts?vue&type=script&lang=ts&"
export * from "./display-contact-link.ts?vue&type=script&lang=ts&"
import style0 from "./display-contact-link.scss?vue&type=style&index=0&id=9161a68a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9161a68a",
  null
  
)

export default component.exports